import { ChangeDetectionStrategy, Component, Input } from '@angular/core';

@Component({
  selector: 'app-details-item-placeholder',
  templateUrl: './details-item-placeholder.component.html',
  styleUrls: ['./details-item-placeholder.component.scss'],
  changeDetection: ChangeDetectionStrategy.Eager,
  imports: [],
})
export class DetailsItemPlaceholderComponent {
  @Input() isPrimary?: boolean;

  @Input() showLabel?: boolean;

  @Input() label?: string;

  @Input() isDarkBg?: boolean;

  @Input() multiline?: boolean;
}
